import { CostEnum, VehicleTypeEnum } from "@project-management-system/shared-models";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { PlantsEntity } from "../plants/plants.entity";

@Entity('root_wise_cost')
export class RootWiseCostEntity {

  @PrimaryGeneratedColumn("increment",{name:'id'})
  id:number;

  @Column("enum", {
    name: "route_type",
    enum: CostEnum,
  })
  routeType: CostEnum;

  @Column("enum", {
    name: "type",
    enum: VehicleTypeEnum,
  })
  type: VehicleTypeEnum;

  @Column('int',{
    name:'from_km_range',
    // length:50,
    nullable: true
  })
  fromKmrange: number;
  @Column('int',{
    name:'plant_id',
    // length:50,
    nullable: true
  })
  plantId: number;

  @Column('int',{
    name:'hrs',
    // length:50,
    nullable: true
  })
  hrs: number;

  @Column('int',{
    name:'vendor_id',
    // length:50,
    nullable: true
  })
  vendorId: number;

  @Column('int',{
    name:'to_km_range',
    // length:50,
    nullable: true
  })
  toKmrange: number;

  @Column('int',{
    name:'cost',
    nullable: true
  })
  cost: number;

  @Column ('varchar',{
    name:'vehicle_type',
    nullable: true
  })
 vehicleType:string;

 @Column ('varchar',{
  name:'criteria',
  nullable: true
})
criteria:string;

@Column ('varchar',{
  name:'agreed_slab',
  nullable: true
})
agreeSlab:string;

@Column ('varchar',{
  name:'per_kms_rate',
  nullable: true
})
perKmsRate:string;

@Column ('varchar',{
  name:'extra_hrs',
  nullable: true
})
extraHrs:string;

@Column ('varchar',{
  name:'local_Batta_bef_aft',
  nullable: true
})
localBattaBefAft:string;

@Column ('varchar',{
  name:'os_batta',
  nullable: true
})
osbatta:string;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
  })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      default: "ADMIN",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user",
      length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;
  
  @ManyToOne(() => PlantsEntity, plant => plant.rootwiseInfo)
    @JoinColumn({ name: 'plant_id' })
    plantsInfo: PlantsEntity;

}